<script lang='ts'>
import type { PropType } from 'vue'
import type { AllResource, TextResource } from '../types/material'
import { saveAs } from 'file-saver'
import { computed, defineComponent, ref } from 'vue'
import { allFileExtension, getFileName, getFileType } from '../utils'

export default defineComponent({
  name: 'MsFileOperate',
  props: {
    fileList: {
      type: Array as PropType<Array<Exclude<AllResource, TextResource>>>,
      required: true,
    },
  },
  setup(props) {
    const isShowPreview = (url: string) => {
      const fileType = getFileType(url)
      return allFileExtension.office.includes(fileType) || allFileExtension.image.includes(fileType) || allFileExtension.other.includes(fileType)
    }

    const handleDown = (url: string) => {
      url && saveAs(url, getFileName(url))
    }

    const previewImageUrl = ref('')
    const previewVisible = ref(false)
    const previewImages = computed(() => {
      return props.fileList
        .map(it => it.url)
        .filter(url => allFileExtension.image.includes(getFileType(url)))
    })

    const previewIndex = computed(() => {
      return (previewImages.value || []).indexOf(previewImageUrl.value)
    })

    const handlePreview = (url: string) => {
      const fileType = getFileType(url)
      if (allFileExtension.office.includes(fileType)) {
        window.open(`https://view.officeapps.live.com/op/view.aspx?src=${url}`)
      } else if (allFileExtension.other.includes(fileType)) {
        window.open(url)
      } else {
        previewImageUrl.value = url
        previewVisible.value = true
      }
    }

    const handlePreviewClose = () => {
      previewVisible.value = false
    }

    return {
      handleDown,
      handlePreview,
      isShowPreview,
      handlePreviewClose,
      previewVisible,
      previewImages,
      previewImageUrl,
      previewIndex,
    }
  },
})
</script>

<template>
  <div class="flex column items-center">
    <div v-for="(item, index) in fileList" :key="index" class="flex justify-start items-center">
      <div class="flex file-name">
        {{ item.name }}
      </div>
      <div class="flex m-mx-ms file-btn">
        <el-button text type="primary" @click="handleDown(item.url)">
          下载
        </el-button>
        <el-button v-if="isShowPreview(item.url)" text type="primary" @click="handlePreview(item.url)">
          预览
        </el-button>
      </div>
    </div>
  </div>
  <el-image-viewer
    v-if="previewVisible" hide-on-click-modal :url-list="previewImages"
    :initial-index="previewIndex" teleported @close="handlePreviewClose"
  />
</template>

<style lang='scss' scoped>
.file-name {
  width: 200px;
}

.file-btn {
  width: 80px;
}
</style>
